import React, { type SyntheticEvent, type ReactNode } from 'react';
import Tooltip from '@atlaskit/tooltip';
import { useIntl } from '@atlassian/jira-intl';
import { LOCKED_CELL_TOOLTIP_SELECTOR } from '../../constants';
import { TableCell } from '../styled';
import messages from './messages';

type LockedCellProps = {
	columnKey: string;
	isLocked: boolean;
	children: ReactNode;
	tooltipDelay?: number;
};

export const LockedCell = ({
	columnKey,
	isLocked = false,
	children,
	tooltipDelay,
}: LockedCellProps) => {
	const { formatMessage } = useIntl();

	const handleClickCapture = (event: SyntheticEvent) => event.stopPropagation();

	if (isLocked)
		return (
			<Tooltip
				testId={LOCKED_CELL_TOOLTIP_SELECTOR}
				content={formatMessage(messages.migrationInfo)}
				delay={tooltipDelay}
			>
				<TableCell
					data-testid={`locked-cell-${columnKey}`}
					isLocked={isLocked}
					onClickCapture={handleClickCapture}
				>
					{children}
				</TableCell>
			</Tooltip>
		);

	return <TableCell data-testid={`unlocked-cell-${columnKey}`}>{children}</TableCell>;
};
